import React from 'react';

import { Grid, Typography } from '@mui/material';
import { Layout } from 'features/common/components/Layout';
import SalesOrderBillingSyncProcessStatus from './Netsuite/components/SalesOrderBillingSyncProcessStatus';

export const SalesOrderBillingSyncProcessStatusPage = (): JSX.Element => {
	return (
		<Layout>
			<Grid container paddingY={5} justifyContent={'center'}>
				<Typography variant="h4" style={{ fontWeight: 500 }}>
					Estado de Proceso de Sincronización de Facturación de Sales Order desde Netsuite
				</Typography>
				<Grid item xs={12} paddingY={5}>
					<SalesOrderBillingSyncProcessStatus />
				</Grid>
			</Grid>
		</Layout>
	);
};
